import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@vant/touch-emulator'
import Vant from 'vant'
import 'vant/lib/index.css'
import { Lazyload } from 'vant'
import './style/index.css'
// import {ApiUrl} from '../public/globalConfig'
// Vue.prototype.baseUrl = ApiUrl;
// vue-cookies配置
import cookies from 'vue-cookies'
Vue.prototype.$cookies = cookies

import toBase from './utils/toBase'
Vue.prototype.$toBase = toBase

import { format } from 'date-fns'
Vue.prototype.moment = format

import { Dialog } from 'vant'

// 全局注册
Vue.use(Dialog)

Vue.use(Lazyload)

Vue.use(Vant)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
